import React, { useEffect, useState } from 'react';
import { CheckCircle } from 'lucide-react';
const NAMES = ['Juan', 'María', 'Carlos', 'Ana', 'Pedro', 'Sofía', 'Miguel', 'Lucía', 'Diego', 'Valentina', 'Fernando', 'Gabriela', 'Ricardo', 'Patricia', 'Martín', 'Laura'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Neuquén', 'Corrientes'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      showPopup();
    }, 5000);
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setData({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
      // Schedule next popup (random between 8-15 seconds + 4s display time)
      const nextDelay = Math.random() * (15000 - 8000) + 8000 + 4000;
      setTimeout(showPopup, nextDelay);
    };
    return () => clearTimeout(initialTimeout);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 right-4 z-50 animate-slide-in-right max-w-sm w-full md:w-auto" data-id="element-203">
      <div className="bg-white rounded-lg shadow-xl p-4 border-l-4 border-green-500 flex items-center gap-4" data-id="element-204">
        <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-205">
          <CheckCircle className="h-6 w-6 text-green-600" data-id="element-206" />
        </div>
        <div data-id="element-207">
          <p className="text-sm font-medium text-gray-900" data-id="element-208">
            <span className="font-bold" data-id="element-209">{data.name}</span> de {data.city}
          </p>
          <p className="text-xs text-gray-500" data-id="element-210">
            acaba de adquirir{' '}
            <span className="font-semibold text-blue-600" data-id="element-211">DERECHO 360</span>
          </p>
          <p className="text-[10px] text-gray-400 mt-1" data-id="element-212">Hace unos instantes</p>
        </div>
      </div>
    </div>;
}